import EventEmitter from 'events';

export const handleLoaderEvent = new EventEmitter();
export const handleAuthEvent = new EventEmitter();